import { render, staticRenderFns } from "./bookingBar.vue?vue&type=template&id=8252a026&scoped=true"
import script from "./bookingBar.vue?vue&type=script&lang=js"
export * from "./bookingBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8252a026",
  null
  
)

export default component.exports